export default __webpack_public_path__ + "static/media/logo_awair_business.2c64c153.svg";